import { useEffect, useRef } from 'react';
import './styles/WebGLBackground.css';

const WebGLBackground = () => {
	const ref = useRef(null);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;
		const onMove = (e) => {
			const x = (e.clientX / window.innerWidth)  * 100;
			const y = (e.clientY / window.innerHeight) * 100;
			el.style.setProperty('--mx', `${x}%`);
			el.style.setProperty('--my', `${y}%`);
		};
		window.addEventListener('mousemove', onMove);
		return () => window.removeEventListener('mousemove', onMove);
	}, []);

	return (
		<div ref={ref} className="hero-bg" aria-hidden="true">
			<div className="orb orb-1" />
			<div className="orb orb-2" />
			<div className="orb orb-3" />
			<div className="orb orb-4" />
			<div className="hero-grid" />
			<div className="hero-mouse-glow" />
			{[...Array(18)].map((_, i) => (
				<span key={i} className="hero-particle" style={{ '--i': i }} />
			))}
		</div>
	);
};

export default WebGLBackground;
